import { render, staticRenderFns } from "./TreatmentList.vue?vue&type=template&id=3100ee8a&"
import script from "./TreatmentList.vue?vue&type=script&lang=js&"
export * from "./TreatmentList.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports